import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const implementationRequirementsConfig: Record<string, FormConfigProps> =
  {
    withClassInClassroom: {
      label: 'kartu su visais klasėje',
      value: 'withClassInClassroom',
    },
    withClassIndividually: {
      label: 'kartu su visais individualioje darbo vietoje',
      value: 'withClassIndividually',
    },
    inSpecialEdRoom: {
      label: 'specialiojo pedagogo kabinete',
      value: 'inSpecialEdRoom',
    },
    separateSpaceWithSpecialist: {
      label: 'kitoje patalpoje su švietimo pagalbą teikiančiu asmeniu',
      value: 'separateSpaceWithSpecialist',
    },
    individuallyLater: {
      label: 'individualiai, kitu laiku',
      value: 'individuallyLater',
    },
    extendedTimeForTasks: {
      label: 'pratęsiant užduočių atlikimo laiką',
      value: 'extendedTimeForTasks',
    },
    useSupportingMaterials: {
      label: 'leidžiant naudotis atramine medžiaga',
      value: 'useSupportingMaterials',
    },
    useAssistiveDevices: {
      label: 'leidžiant naudotis specialiosiomis mokymo priemonėmis',
      value: 'useAssistiveDevices',
    },
    belowThresholdLevel: {
      label: 'nepasiekus slenkstinio pasiekimų lygio:',
      value: 'belowThresholdLevel',
      children: {
        analyzeReasons: {
          label: 'analizuojamos priežastys',
          value: 'analyzeReasons',
          paddingLeft: 24,
        },
        additionalAdjustments: {
          label: 'numatomi papildomi pritaikymai',
          value: 'additionalAdjustments',
          paddingLeft: 24,
        },
        retakeAfterSupport: {
          label:
            'suteikus papildomą pagalbą, parinkus papildomas pritaikytas užduotis, leidžiama pakartotinai atsiskaityti',
          value: 'retakeAfterSupport',
          paddingLeft: 24,
        },
      },
    },
    other: {
      label: 'kita:',
      value: 'other',
      isInput: true,
    },
  };

export const Block42 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 7 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Atlikimo sąlygos:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={implementationRequirementsConfig}
          formPathParams={['subject', 'block4', 'implementationRequirements']}
          form={form}
        />
      </div>
    );
  },
);
